import styled from 'styled-components'

export const TemplatesSelectStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
